export default __webpack_public_path__ + "static/media/pileofgold2.37605aa5.png";